exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-invalid .custom-file-label{border:1px solid #dc3545}", ""]);

// exports
